import {languageIsRtl} from "@wix/devzai-utils-common";

import {
    useAssertDoppeViewerLangReactContext
} from "../doppe-viewer-bymo-page-props-react/doppe-viewer-bymo-page-props-react";

export function useDoppViewerIsRtl () {
    return languageIsRtl(useAssertDoppeViewerLangReactContext());
}